import { render, staticRenderFns } from "./UnidadeParceiraFilterBar.vue?vue&type=template&id=b8d25742"
import script from "./UnidadeParceiraFilterBar.vue?vue&type=script&lang=js"
export * from "./UnidadeParceiraFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports